function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["externalDisplayName"],
  _excluded2 = ["stages"];
var _z$object$transform$r, _z$object$transform$r2, _z$object$transform, _z$array, _z$object$transform$r3, _z$object$transform$r4, _z$object$transform2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.filter.js";
import { match } from 'ts-pattern';
import { z } from 'zod';
import { iso8601DurationRegex } from "../utils/duration";
import { allItemsUniqueRefinement } from "./utils";
var stepStatusConsistentWithSubStepStatusesRefinement = [function (data) {
  if (!data.subSteps || data.subSteps.length === 0) {
    return true;
  }
  return match(data.status)["with"]('planned', function () {
    var _data$subSteps;
    return (_data$subSteps = data.subSteps) === null || _data$subSteps === void 0 ? void 0 : _data$subSteps.every(function (subStep) {
      return subStep.status !== 'completed';
    });
  })["with"]('in_progress', function () {
    var _data$subSteps2;
    return (_data$subSteps2 = data.subSteps) === null || _data$subSteps2 === void 0 ? void 0 : _data$subSteps2.some(function (subStep) {
      return subStep.status === 'in_progress' || subStep.status === 'planned';
    });
  })["with"]('paused', function () {
    return true;
  }) // No need to worry about paused status, since we won't show the subSteps in that case
  ["with"]('completed', function () {
    var _data$subSteps3;
    return (_data$subSteps3 = data.subSteps) === null || _data$subSteps3 === void 0 ? void 0 : _data$subSteps3.every(function (subStep) {
      return subStep.status === 'completed';
    });
  }).exhaustive();
}, {
  message: 'Step status is not consistent with subStep statuses'
}];
var subStepStatusesInCorrectOrderRefinement = [function (data) {
  if (!data.subSteps || data.subSteps.length === 0) {
    return true;
  }
  var statusOrder = ['completed', 'in_progress', 'planned'];
  var maxSeenIndex = -1;
  return data.subSteps.every(function (subStep) {
    var currentIndex = statusOrder.indexOf(subStep.status);
    if (currentIndex < maxSeenIndex) {
      return false;
    }
    maxSeenIndex = currentIndex;
    return true;
  });
}, {
  message: 'SubStep statuses are not in order. Must be completed -> in_progress -> planned'
}];
var bothOrNeitherDeadlinesRefinement = [function (data) {
  return data.applicantActionDeadline && data.completionDeadline || !data.applicantActionDeadline && !data.completionDeadline;
}, {
  // See: https://applyboard.slack.com/archives/C06ME2XT59V/p1743452077651149?thread_ts=1743450332.080919&cid=C06ME2XT59V
  message: 'Either both applicantActionDeadline and completionDeadline must be provided, or neither.'
}];
export var ApplicationStep = (_z$object$transform$r = (_z$object$transform$r2 = (_z$object$transform = z.object({
  id: z.string(),
  status: z["enum"](['completed', 'in_progress', 'paused', 'planned']),
  internalDisplayName: z.string().nullish(),
  applicantActionDeadline: z.string().nullish(),
  completionDeadline: z.string().nullish(),
  displayName: z.string().nullish(),
  externalDisplayName: z.string().nullish(),
  // TODO: check with BE team if we're renaming this to just `displayName` ?
  description: z.string().nullish(),
  internalDescription: z.string().nullish(),
  recommendedActions: (_z$array = z.array(z["enum"](['manage_backup_programs', 'get_recommended_programs']))).refine.apply(_z$array, _toConsumableArray(allItemsUniqueRefinement)).nullish(),
  estimatedProcessingTime: z.object({
    min: z.string().regex(iso8601DurationRegex),
    max: z.string().regex(iso8601DurationRegex)
  }).nullish(),
  subSteps: z.array(z.object({
    id: z.string(),
    internalDisplayName: z.string().nullish(),
    displayName: z.string(),
    status: z["enum"](['completed', 'in_progress', 'planned'])
  })).nullish()
}).transform(function (_ref) {
  var externalDisplayName = _ref.externalDisplayName,
    item = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, item), {}, {
    displayName: item.displayName || externalDisplayName || '' // TODO: remove this after BE team renames `externalDisplayName`
  });
})).refine.apply(_z$object$transform, bothOrNeitherDeadlinesRefinement)).refine.apply(_z$object$transform$r2, stepStatusConsistentWithSubStepStatusesRefinement)).refine.apply(_z$object$transform$r, subStepStatusesInCorrectOrderRefinement);
var zeroOrOneInProgressStepRefinement = [function (data) {
  return (data.steps || []).filter(function (step) {
    return step.status === 'in_progress' || step.status === 'paused';
  }).length <= 1;
}, {
  message: 'There must be zero or one in_progress and paused steps'
}];
var stepStatusesInCorrectOrderRefinement = [function (data) {
  var statusOrder = ['completed', 'in_progress', 'paused', 'planned'];
  var maxSeenIndex = -1;
  return (data.steps || []).every(function (step) {
    var currentIndex = statusOrder.indexOf(step.status);
    if (currentIndex < maxSeenIndex) {
      return false;
    }
    maxSeenIndex = currentIndex;
    return true;
  });
}, {
  message: 'Step statuses are not in order. Must be completed -> in_progress (or paused) -> planned'
}];
var overallStatusConsistentWithStepStatusesRefinement = [function (data) {
  return match(data.status)["with"]('in_progress', function () {
    return data.steps.some(function (step) {
      return step.status === 'in_progress';
    });
  })["with"]('paused', function () {
    return data.steps.some(function (step) {
      return step.status === 'paused';
    });
  })["with"]('completed', function () {
    return data.steps.every(function (step) {
      return step.status === 'completed';
    });
  }).exhaustive();
}, {
  message: 'Overall status is not consistent with step statuses'
}];
export var ApplicationWorkflow = (_z$object$transform$r3 = (_z$object$transform$r4 = (_z$object$transform2 = z.object({
  id: z.string(),
  status: z["enum"](['in_progress', 'completed', 'paused']),
  category: z["enum"](['main', 'secondary']),
  // TODO: remove stages after https://applyboard.atlassian.net/browse/AWA-5946
  stages: z.array(ApplicationStep).nullish(),
  steps: z.array(ApplicationStep).nullish()
}).transform(function (_ref2) {
  var stages = _ref2.stages,
    item = _objectWithoutProperties(_ref2, _excluded2);
  return _objectSpread(_objectSpread({}, item), {}, {
    steps: stages || item.steps || []
  });
})).refine.apply(_z$object$transform2, zeroOrOneInProgressStepRefinement)).refine.apply(_z$object$transform$r4, stepStatusesInCorrectOrderRefinement)).refine.apply(_z$object$transform$r3, overallStatusConsistentWithStepStatusesRefinement);
export var ApplicationWorkflowResponse = z.object({
  attributes: z.object({}).passthrough(),
  id: z.string(),
  type: z.literal('application_workflow')
});